import { useQuery } from "react-query";
import { useAxios } from "@/context/axios/AxiosContext";
import { useAuthUser } from "@/context/auth/AuthContext";
import { querykeys } from "../constants";

export interface WhitelistStatusResponse {
  isWhitelisted: boolean;
  isAlreadyBigSupplier: boolean;
  bigSupplierId?: string;
  bigSupplierIsActive?: boolean;
  bigSupplierType?: string;
}

function useGetWhitelistStatus() {
  const axios = useAxios();
  const user = useAuthUser();

  const query = useQuery<WhitelistStatusResponse>(
    [querykeys.bigSupplierWhitelistStatus, user?.businessId],
    async () => {
      const { data } = await axios.get("/big-supplier/whitelist-status");
      return data;
    },
    {
      staleTime: 5 * 60 * 1000,
      enabled: !!user?.businessId,
    }
  );

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export default useGetWhitelistStatus;
